import { API_BASE_URL } from "@/config";
import { validateToken } from '@/utils/auth';

export default {
  name: 'ConfirmWorkflow',

  data: () => ({
    custom_services: [],
    workflow_services: [],
    workflow_data: '',
    total_costs: null,
    terms_and_conditions_document: ''
  }),
  computed: {
    workflow_id() {
      return this.$store.getters.get_workflow_id;
    },
    project_id() {
      return this.$store.getters.get_project_id;
    }
  },

  methods: {
    get_workflow_information() {
      const TOKEN = localStorage.getItem('token');
      const GET_WORKFLOW_INFORMATION = `${API_BASE_URL}/verify_api/workflow_management_api/get_workflow_data_api/${this.workflow_id}`;

      $.ajax({
        url: GET_WORKFLOW_INFORMATION,
        method: 'GET',
        contentType: 'application/json',
        headers: {
          Authorization: `Token ${TOKEN}`
        },
        beforeSend: () => {
          Swal.fire({
            text: 'Loading ...',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            }
          });
        },
        success: (response) => {
          Swal.close();        
          this.custom_services = response.workflow_services.filter(
            serviceObj => !serviceObj.service.service_details || serviceObj.service.service_details.length === 0
          );
          this.workflow_services = response.workflow_services.filter(
            serviceObj => serviceObj.service.service_details && serviceObj.service.service_details.length > 0
          );
          this.workflow_data = (Array.isArray(response.workflow_data) && response.workflow_data.length > 0)
            ? response.workflow_data[0]
            : {};
        
          this.total_costs = response.total_cost;
          this.terms_and_conditions_document = response.terms_and_conditions_document;
        },
        
        error: () => {
          Swal.close();
        }
      });
    },

    async confirm_workflow() {
      const TOKEN = localStorage.getItem('token');
      const BASE_URL = API_BASE_URL;
      const ENDPOINTS = {
          CONFIRM_WORKFLOW: `${BASE_URL}/verify_api/workflow_management_api/confirm_workflow_api/${this.workflow_id}`,
          CHECK_STATUS: `${BASE_URL}/verify_api/workflow_management_api/get_workflow_status/${this.workflow_id}`,
          UPDATE_STATUS: `${BASE_URL}/verify_api/workflow_management_api/edit_workflow_api/`
      };
  
      let showSuccessMessage = false;
  
      try {
          // Show initial loading
          Swal.fire({
              text: 'Loading ...',
              allowEscapeKey: false,
              allowOutsideClick: false,
              didOpen: () => {
                  Swal.showLoading();
              }
          });
  
          // Check workflow status
          const statusResponse = await $.ajax({
              url: ENDPOINTS.CHECK_STATUS,
              method: 'GET',
              headers: {
                  Authorization: `Token ${TOKEN}`
              }
          });
  
          // If workflow is approved, show confirmation dialog
          if (statusResponse.status === 'approved') {
              Swal.close();
              const result = await Swal.fire({
                  title: 'Warning',
                  text: 'This workflow is currently approved. Making changes will set it back to incomplete status. Do you want to continue?',
                  icon: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Yes, continue',
                  cancelButtonText: 'No, cancel',
                  cancelButtonColor: '#d33'
              });
  
              if (!result.isConfirmed) {
                  return;
              }
  
              showSuccessMessage = true;
  
              // Show loading for status update
              Swal.fire({
                  text: 'Updating status...',
                  allowEscapeKey: false,
                  allowOutsideClick: false,
                  didOpen: () => {
                      Swal.showLoading();
                  }
              });
  
              // Update status to incomplete if user confirms
              await $.ajax({
                  url: ENDPOINTS.UPDATE_STATUS,
                  method: 'POST',
                  contentType: 'application/json',
                  data: JSON.stringify({
                      workflow_id: this.workflow_id,
                      status: 'incomplete'
                  }),
                  headers: {
                      Authorization: `Token ${TOKEN}`
                  }
              });
          }
  
          // Show loading for confirmation
          Swal.fire({
              text: 'Confirming workflow...',
              allowEscapeKey: false,
              allowOutsideClick: false,
              didOpen: () => {
                  Swal.showLoading();
              }
          });
  
          // Proceed with confirming workflow
          const response = await $.ajax({
              url: ENDPOINTS.CONFIRM_WORKFLOW,
              method: 'POST',
              contentType: 'application/json',
              headers: {
                  Authorization: `Token ${TOKEN}`
              },
              data: JSON.stringify({
                  confirm_workflow: true
              })
          });
  
          Swal.close();
  
          if (response.status === 'error') {
              await Swal.fire({
                  text: response.message,
                  icon: 'error',
                  confirmButtonText: 'OK'
              });
          } else if (response.status === 'incomplete workflow') {
              await Swal.fire({
                  text: response.message,
                  icon: 'error',
                  confirmButtonText: 'OK'
              });
              this.$router.push({ name: 'edit_workflow' });
          } else if (response.status === 'success') {
              if (showSuccessMessage) {
                  await Swal.fire({
                      text: 'Workflow confirmed successfully',
                      icon: 'success',
                      confirmButtonText: 'OK'
                  });
              }
              this.$router.push({ name: 'project_dashboard' });
          }
  
      } catch (error) {
          Swal.close();
          let error_message = 'Failed to confirm workflow';
          if (error.responseJSON?.message) {
              error_message = error.responseJSON.message;
          }
  
          await Swal.fire({
              text: error_message,
              icon: 'error',
              confirmButtonText: 'OK'
          });
      }
  },

    back_to() {
      this.$router.push({
        name: 'reasons_for_usage',
      });
    },
  },

  mounted() {
    if (!validateToken(this.$router)) {
      return;
  }
    this.get_workflow_information();
  }
};
